import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { uploadPercent } from '../../api/reconFileUpload';
import { uploadReconFile } from '../../api/reconFileUploadClient';
import ReactDropzone from 'react-dropzone';
import { updateInstallation } from '../../actions/apiDealerUpdates';
import './uploadProgress.scss';

class DropBoxDealer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: false,
			progress: 0,
			uploadError: '',
		};

		this.onDrop = this.onDrop.bind(this);
	}

	failUpload(error) {
		this.uploadActive = false;
		this.setState({
			loading: false,
			progress: 0,
			uploadError: (error && error.message) || 'Upload failed.',
		});
	}

	publishProgress(loaded, totals) {
		if (!this.uploadActive) return;
		const parts = loaded.map((sent, index) => ({ loaded: sent, total: totals[index] }));
		this.setState({ progress: uploadPercent(parts) });
	}

	startUploads(files) {
		const list = files || [];
		if (!list.length) return Promise.resolve();
		this.uploadActive = true;
		const loaded = list.map(() => 0);
		const totals = list.map(file => (file && file.size) || 0);
		this.setState({
			loading: true,
			progress: 0,
			uploadError: '',
		});
		return Promise.all(list.map((file, index) => this.fileUpload(file, (event) => {
			if (!event) return;
			loaded[index] = event.loaded || 0;
			if (event.total) totals[index] = event.total;
			this.publishProgress(loaded, totals);
		}).then(() => {
			loaded[index] = totals[index];
			this.publishProgress(loaded, totals);
		}))).then(() => {
			if (!this.uploadActive) return;
			this.uploadActive = false;
			this.setState({ loading: false, progress: 100 });
		}).catch(() => {});
	}

	onDrop(files) {
		const logo = files && files[0];
		this.startUploads(logo ? [logo] : []);
	}

	saveLogo(fileurl) {
		const { installation } = this.props;
		return this.props.updateInstallation(installation, { id: installation, logo: fileurl }, 'updateInstallation').then((result) => {
			if (result && result.errors) {
				const message = result.errors.updateInstallation || 'Upload failed.';
				this.failUpload(new Error(message));
				return Promise.reject(new Error(message));
			}
			return result;
		});
	}

	fileUpload(file, onProgress) {
		const url = "https://gotoreconfiles.com/cors_new_server.php";
		const { siteid } = this.props;
		const fileid = file.name.replace(/#/g, '');
		const postPhp = () => {
			const data = new FormData();
			data.append('data', file);
			data.append('action', 'put-newserver-file');
			data.append('fileid', fileid);
			data.append('siteid', siteid);

			return axios.post(url, data, {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
				onUploadProgress: onProgress,
			}).then(response => this.saveLogo(response.data));
		};

		return uploadReconFile({
			kind: 'logo',
			file,
			onProgress,
		}).then((uploaded) => {
			if (!uploaded) return postPhp();
			return this.saveLogo(uploaded.url);
		}).catch(error => {
			this.failUpload(error);
			return Promise.reject(error);
		});
	}

	renderProgress() {
		return (
			<div
				className="upload-progress form-control"
				role="progressbar"
				aria-label="Upload progress"
				aria-valuenow={this.state.progress}
				aria-valuemin="0"
				aria-valuemax="100"
				aria-busy="true"
			>
				<div className="upload-progress-fill" style={{ width: `${this.state.progress}%` }} />
				<span className="upload-progress-label">{this.state.progress < 100 ? 'Uploading...' : 'Complete!'}</span>
			</div>
		);
	}

	renderDrop() {
		return (
			<ReactDropzone multiple={false} onDrop={this.onDrop}>
				{({ getRootProps, getInputProps }) => (
					<div {...getRootProps()}>
						<input {...getInputProps()} />
						<button type="button" className="form-control text-center btn btn-success btn-large">Drop Logo Here or Click to Browse</button>
					</div>
				)}
			</ReactDropzone>
		);
	}

	render() {
		return (
			<div className="row">
				<div className="col-md-12">
					<div className="dropzone">
						{this.state.loading ? this.renderProgress() : this.renderDrop()}
					</div>
					{this.state.uploadError ? <p className="text-danger mb-0">{this.state.uploadError}</p> : null}
				</div>
			</div>
		);
	}
}

const mappedActions = {
	updateInstallation,
};

export default connect(null, mappedActions)(DropBoxDealer);
